<template>
  <div class="dc-menu"
       :class="{
          scrolled
       }"
       :style="{
          'left': cx + 'px',
          'top': cy + 'px',
      }">
    <template v-if="!isOnlineBooking">
      <DMenuItem :type="'PAY'"
                 v-if="isTreatment && record.is_paid != '1' && rights.includes('accept_payments')"
                 @click="acceptPayment"
                 :title="$t('accept_payment')" />
      <DMenuItem :type="'CONFIRM'"
                 v-if="isTreatment && record && record.readableStatus === 'not_confirmed' && canBeEdited && rights.includes('recording_status')"
                 @click="confirmVisit"
                 :title="$t('confirm_visit')" />
      <DMenuItem :type="'CAME'"
                 v-if="isTreatment && record && ['confirmed'].includes(record.readableStatus) && canBeEdited && rights.includes('recording_status')"
                 @click="patientCame"
                 :title="$t('patient_came')" />
      <DMenuItem :type="'VIEW'"
                 v-if="canEditRecords"
                 :title="$t('edit_visit')"
                 @click="quickView" />
      <DMenuItem :type="'EDIT'"
                 v-if="isTreatment && canBeEdited && canEditRecords"
                 :title="$t('fill_treatment')"
                 @click="navigateToVisit" />
      <DMenuItem :type="'PATIENT'"
                 v-if="patient && rights.includes('patient_card')"
                 @click="navigateToPatientCard"
                 :title="$t('patient_card')" />
      <DMenuItem :type="'PHONE'"
                 v-if="patient && patient.phone && !rights.includes('hide_patient_phone')"
                 @click="callPhone"
                 :title="patient.phone" />
      <b-dropdown variant="link"
                  class="w-100"
                  v-if="patient && !rights.includes('hide_patient_phone')">
        <template #button-content>
          <DMenuItem :type="'EMAIL'"
                     :show-arrow="true"
                     :title="$t('write')" />
        </template>
        <DMenuItem :type="'SMS'"
                   v-if="patient.phone && rights.includes('sms_send') && !rights.includes('hide_patient_phone')"
                   @click="sendSms"
                   :title="$t('send_sms')" />
        <DMenuItem :type="'EMAIL'"
                   v-if="patient.email && rights.includes('emailing')"
                   @click="sendMail"
                   :title="$t('send_mail')" />
        <DMenuItem :type="'WHATSAPP'"
                   v-if="wazzupEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="wazzupIframe('whatsapp')"
                   :title="`Whatsapp`"/>
        <DMenuItem :type="'TELEGRAM'"
                   v-if="wazzupEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="wazzupIframe('telegram')"
                   :title="`Telegram`"/>
        <DMenuItem :type="'WHATSAPP'"
                   v-if="jetAPILink && jetAPIPanelEnabled && !wazzupEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="launchJetorGreenAPISidebar('whatsapp')"
                   :title="`Whatsapp`"/>
        <DMenuItem :type="'TELEGRAM'"
                   v-if="jetAPILink && jetAPIPanelEnabled && !wazzupEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="launchJetorGreenAPISidebar('tdlib')"
                   :title="`Telegram`"/>
        <DMenuItem :type="'WHATSAPP'"
                   v-if="greenApiframeUrl && !(jetAPILink && jetAPIPanelEnabled) && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="launchJetorGreenAPISidebar"
                   :title="`Whatsapp`"/>
        <DMenuItem :type="'WHATSAPP'"
                   v-if="patient.phone && !wazzupEnabled && !(jetAPILink && jetAPIPanelEnabled) && !greenApiframeUrl && !rights.includes('hide_patient_phone')"
                   @click="openLink(`https://wa.me/${formatPhone(patient.phone, false)}`)"
                   :title="`Whatsapp`"/>
        <DMenuItem :type="'TELEGRAM'"
                   v-if="patient.phone && !wazzupEnabled && !(jetAPILink && jetAPIPanelEnabled) && !greenApiframeUrl && !rights.includes('hide_patient_phone')"
                   @click="openLink(`https://t.me/${formatPhone(patient.phone)}`)"
                   :title="`Telegram`"/>
        <DMenuItem :type="'MAX'"
                   v-if="jetAPILink && jetAPIPanelEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="launchJetorGreenAPISidebar('max')"
                   :title="`Max`"/>
        <DMenuItem :type="'WHATSAPP'"
                   v-if="auraPanelEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="launchJetorGreenAPISidebar('whatsapp')"
                   :title="`Whatsapp (${$t('chat_panel')})`"/>
        <DMenuItem :type="'TELEGRAM'"
                   v-if="greenApiframeUrl && greenAPITelegramPanelEnabled && patient.phone && !rights.includes('hide_patient_phone')"
                   @click="launchJetorGreenAPISidebar('telegram')"
                   :title="`Telegram (${$t('chat_panel')})`"/>
      </b-dropdown>
      <!--      <DMenuItem :type="'SMS'"-->
      <!--                 v-if="patient && patient.phone && rights.includes('sms_send') && !rights.includes('hide_patient_phone')"-->
      <!--                 @click="sendSms"-->
      <!--                 :title="$t('send_sms')" />-->
      <DMenuItem :type="'MOVE'"
                 v-if="canEditRecords"
                 @click="moveRecord"
                 :title="$t('move_record')" />
      <DMenuItem :type="'COPY'"
                 v-if="rights.includes('add_records')"
                 @click="copyRecord"
                 :title="$t('record_again')" />
      <div class="line" v-if="isTreatment && canBeEdited && record.is_paid != '1' && rights.includes('add_records') && rights.includes('recording_status')"></div>
      <DMenuItem :type="'DID_NOT_COME'"
                 v-if="isTreatment && record && ['confirmed','not_confirmed'].includes(record.readableStatus) && canBeEdited && rights.includes('recording_status')"
                 @click="patientDidNotCome"
                 :title="$t('did_not_come')" />
      <DMenuItem :type="'CANCEL'"
                 v-if="isTreatment && canBeEdited && record.is_paid != '1' && rights.includes('add_records') && rights.includes('recording_status')"
                 :title="$t('cancel_record')"
                 @click="cancelRecord" />
      <DMenuItem :type="'DELETE'"
                 v-if="!isTreatment && canBeEdited && record.is_paid != '1' && rights.includes('add_records')"
                 :title="isTreatment ? $t('delete_record') : $t('delete')"
                 @click="deleteRecord" />
    </template>
    <template v-if="isOnlineBooking">
      <DMenuItem :type="'CAME'"
                 v-if="rights.includes('add_records')"
                 :title="$t('confirm_visit')"
                 @click="confirmOnline" />
      <DMenuItem :type="'CANCEL'"
                 v-if="canBeEdited && record.is_paid != '1' && rights.includes('add_records') && rights.includes('recording_status')"
                 :title="$t('cancel_record')"
                 @click="cancelRecord" />
    </template>
  </div>
</template>

<script setup>
import DMenuItem from "@/components/pages/calendar/calendar/DMenuItem"
import { EloquentService } from "@/services/api/eloquent.api.service"
import { CalendarService } from "@/services/api/calendar.api.service"
import moment from "moment"
import { makeCall } from "@/services/call.service"
import {appendFormdata, copyObject} from "@/extensions/prototypes/prototypes"
import {computed, getCurrentInstance, inject, nextTick, onBeforeMount, onMounted, onUnmounted, ref} from 'vue'
import {useStore} from "vuex"
import {useRouter} from "vue-router"
import {formatPhone} from "@/extensions/filters/filters"
import {WhatsappService} from "@/services/api/whatsapp.api.service"

const store = useStore()
const router = useRouter()

let bvModal = null
let noty = null
let i18n = null

const props = defineProps({
  record: Object,
  cordX: Number,
  cordY: Number,
  contextMenuHeight: Number
})

const showReasonPrompt = inject('showReasonPrompt')
const offset = ref(40)
const cx = ref(props.cordX)
const cy = ref(props.cordY + offset.value)
const initialY = ref(document.documentElement.scrollTop || document.body.scrollTop)
const clicksEnabled = ref(false)
const scrolled = ref(false)

const getters = store.getters
const rights = computed(() => store.state.auth.rights)
const clinic = computed(() => store.state.auth.clinic)
const user = computed(() => store.state.auth.user)
const patient = computed(() => props.record?.patient || {})
const isTreatment = computed(() => props.record?.record_type !== 'block')
const isOnlineBooking = computed(() => props.record?.record_type === 'online')
const additional = computed(() => clinic.value.clinic_additional)
const dynamicConfigValue = computed(() => getters.dynamicConfigValue)
const jetAPILink = computed(() => dynamicConfigValue.value('jetapi_iframe_url'))
const jetAPIPanelEnabled = computed(() => getters.jetAPIPanelEnabled)
const wazzupEnabled = computed(() => store.state.crm.wazzupEnabled)
const auraPanelEnabled = computed(() => getters.auraPanelEnabled)
const greenApiframeUrl = computed(() => getters.greenAPIIframeUrl(patient.value?.phone || null))
const greenAPITelegramPanelEnabled = computed(() => getters.greenAPITelegramPanelEnabled)
const canBeEdited = computed(() => {
  if(!props.record) return false
  if(props.record.startMoment.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && rights.value.includes('records_during_day')) {
    return true
  }
  return !(props.record.hasPassed && !rights.value.includes('edit_history'))
})
const canEditRecords = computed(() => {
  if(rights.value.includes('add_records')) return true
  if(props.record?.doctor_id === user.value.id && rights.value.includes('edit_own_records')) {
    return true
  }
  return false
})

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  noty = instance?.appContext?.app?.noty
  bvModal = instance?.ctx?._bv__modal
  i18n = instance?.ctx?.$i18n
})

onMounted(() => {
  if((window.innerHeight - props.contextMenuHeight) >= props.cordY) {
    offset.value = 0
  }
  window.addEventListener('scroll', handleScroll)
  handleScroll(true)
  setTimeout(() => clicksEnabled.value = true, 250)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

const handleScroll = (initial = false) => {
  if(initial !== true) scrolled.value = true
  const top = document.documentElement.scrollTop || document.body.scrollTop
  cy.value = props.cordY - top + initialY.value + offset.value
}

const navigateToVisit = () => {
  if(!clicksEnabled.value) return
  router.push({
    name: 'PatientVisitPage',
    params: {
      id: props.record.client_id,
      visitid: props.record.id,
      page: 'teeth'
    }
  }).catch(()=>{})
}

const quickView = () => {
  if(!clicksEnabled.value) return
  store.commit('setNewVisit', {
    id: props.record.id,
    client_id: props.record.client_id
  })
  bvModal.show('add-new-visit-modal')
}

const confirmOnline = () => {
  if(!clicksEnabled.value) return
  let chair = null
  if(!props.record.chair && props.record.doctor_id) { // trying to get chair from schedule
    chair = store.getters.getChairForRecord(props.record)
  }
  store.commit('setNewVisit', {
    id: props.record.id,
    client_id: props.record.patient,
    chair_id: chair?.id || null,
    chair
  })
  bvModal.show('add-new-visit-modal')
}

const navigateToPatientCard = () => {
  if(!clicksEnabled.value) return
  router.push({
    name: 'PatientVisits',
    params: {
      id: props.record.client_id,
    }
  }).catch(()=>{})
}

const sendMail = () => {
  if(!clicksEnabled.value) return
  store.commit('setPatient', copyObject(patient.value))
  bvModal.show('send-mail-modal')
}

const sendSms = () => {
  if(!clicksEnabled.value) return
  store.commit('setPatient', copyObject(patient.value))
  bvModal.show('patient-sms-modal')
}

const callPhone = () => {
  if(!clicksEnabled.value) return
  makeCall(clinic.value, patient.value.phone)
}

const moveRecord = () => {
  if(!clicksEnabled.value) return
  store.commit('setRecordToMove', props.record)
  store.commit('setContextMenuVisible', false)
}

const copyRecord = () => {
  if(!clicksEnabled.value) return
  store.commit('setRecordToCopy', props.record)
  store.commit('setContextMenuVisible', false)
}

const confirmVisit = () => {
  if(!clicksEnabled.value) return
  changeStatus(2)
}

const patientCame = () => {
  if(!clicksEnabled.value) return
  changeStatus(3)
}

const patientDidNotCome = async () => {
  if(!clicksEnabled.value) return
  let reason = ''
  if(additional.value.ask_reason_not_come) {
    reason = await showReasonPrompt()
    if(!reason) return
  }
  changeStatus(5, reason)
}

const changeStatus = (status, reason = null) => {
  if(!reason) reason = 'hello'
  let formData = new FormData()
  formData = appendFormdata(formData, { records_statuses_id: status, reason })
  EloquentService.update('record', props.record.id, formData).then(() => {
    noty.info(i18n.t('success_message'))
    store.commit('incrementDataTableCounter')
  }).catch((e) => {
    console.log(e)
  })
}

const acceptPayment = async () => {
  if(!clicksEnabled.value) return
  await store.dispatch('updatePatientDataForPayment', patient.value)
  store.commit('setVisit', copyObject(props.record))
  await nextTick()
  bvModal.show('visit-pay-modal')
}

const deleteRecord = () => {
  if(!clicksEnabled.value) return
  if(confirm(i18n.t('are_you_sure_you_want_to_delete_record'))) {
    EloquentService.delete('record', props.record.id).then(() => {
      noty.info(i18n.t('success_message'))
      store.commit('incrementDataTableCounter')
    })
  }
}

const cancelRecord = async () => {
  if(!clicksEnabled.value) return
  let reason = ''
  if(additional.value.ask_reason_cancel) {
    reason = await showReasonPrompt()
    if(!reason) return
  }
  CalendarService.cancelRecord(props.record.id, reason).then(() => {
    noty.info(i18n.t('success_message'))
    store.commit('incrementDataTableCounter')
  }).catch((e) => {
    console.log(e)
  })
}

const launchJetorGreenAPISidebar = (channel = 'whatsapp') => {
  if(!patient.value?.id) return
  store.commit('setPhoneForJetApi', {
    phone: formatPhone(patient.value.phone, false, true),
    channel
  })
  store.commit('setMessengerPanelPlatform', channel)
  store.commit('setRightPaneOpened', true)
}

const wazzupIframe = async (type = 'whatsapp') => {
  if(!patient.value?.id) return
  let res = await WhatsappService.createIframe(patient.value?.id, type)
  if(res.data.url) {
    store.commit('setWazzupIframeUrl', res.data.url)
    await nextTick()
    bvModal.show('wazzup-iframe-modal')
    return
  }
  if(res.data.error) {
    noty.error(res.data.error)
  }
}

const openLink = (url) => {
  window.open(url, '_blank')
}
</script>
